import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { EffectiveMarginTarget } from "models/project-margin-target"
import { ProjectMarginTargetsSliceState, setEffectiveMarginTarget } from "slices/project-managment/margin-targets/reducer"
import { getEffectiveMarginTarget } from "slices/project-managment/margin-targets/thunk"

// Margin bands for a fiscal year (omit it for the current one). Loads once and caches in Redux.
// Returns null until loaded; callers fall back to FALLBACK_MARGIN_BANDS meanwhile.
const useProjectMarginTarget = (fiscalYear?: number): EffectiveMarginTarget | null => {
    const dispatch: any = useDispatch()
    const { byFiscalYear, currentFiscalYear }: ProjectMarginTargetsSliceState = useSelector((state: any) => state.ProjectMarginTargets)

    const key = fiscalYear ?? currentFiscalYear
    const cached = key ? byFiscalYear[key] : undefined

    useEffect(() => {
        if (cached) return
        let cancelled = false
        getEffectiveMarginTarget(fiscalYear).then(target => {
            if (target && !cancelled) dispatch(setEffectiveMarginTarget({ target, isCurrent: fiscalYear === undefined }))
        })
        return () => { cancelled = true }
    }, [fiscalYear, cached])

    return cached ?? null
}

export default useProjectMarginTarget
